import navTree from './navTree.js'
import footer from './footer.js'
import appList from './appList'

// import ceshi from './ceshi.js'
const config = {
  navTree,
  appList,
  footer,
}
export default config
